module.exports = __webpack_public_path__ + "img/new_index_customers4.3d35aa7e.png";